import React from "react";
import _ from "lodash";
import * as Yup from "yup";

import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import buildNumberInputDefinition, {
    NumberInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/number-input-definition";
import buildSelectMenuDefinition, {
    SelectMenuDefinition
} from "../../../../../../../utils/forms/models/grid-fields/select-menu-definition";
import buildButtonSelectorDefinition, {
    ButtonSelectorDefinition
} from "../../../../../../../utils/forms/models/grid-fields/button-selector-definition";
import buildSwitchDefinition, {
    SwitchDefinition
} from "../../../../../../../utils/forms/models/grid-fields/switch-definition";
import buildDateInputDefinition, {
    DateInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/date-input-definition";
import {FormDefinition} from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import {FormGridField} from "../../../../../../../utils/forms/components/FormGrid";
//import { checkIfConditionMeet } from "../../../../../../../utils/utils";

export const CONFIGURATION_TITLE = "General Settings";

export enum SCHEMA_NAMES {
    //TAX = "tax",
    MAX_BET = "max_bet",
    MIN_TOTAL_BET = "min_total_bet",
    //REPORT_TIME = "report_time",
    AUTO_CASH_OUT = "auto_cash_out",
    POINTS_SYSTEM = "points_system",
    AUTO_SESSION_TIME = "auto_session_time",
    AUTO_SESSION_ENABLED = "auto_session_enabled",
    UPDATE_TIME = "update_time",
    ENABLE_PROG_GLOBAL = "enable_prog_global",
    GLOBAL_PROG_MASTER = "global_prog_master",
    GLOBAL_PROG_SERVER = "global_prog_server",
    //COMMUNICATION_PROTOCOLS = "communications_protocol", // REMOVE COMMUNICATION PROTOCOLS
    GAME_TYPES = "game_types",
    ENABLE_MEGA = "enable_mega",
    ENABLE_PIG_BOOM = "enable_pig_boom",
    ENABLE_MR_CHAMPION = "enable_mr_champion",
    EXTRAS_COUNT = "extras_count_towards_bet",
    EXTRA_BALL_PURCHASE = "extra_ball_purchase",
    PLAY_JACKPOT_SOUND_IN_GROUPS = "play_jackpot_sound_all",
    MINIMUM_VALUE_PROGRESSIVE_HANDPAY = "minimum_value_progressive_handpay",
    REGION = "region",
    RESET_ON_SUPERVISOR = "reload_adm",
    RESET_ON_CASHIN = "reload_in",
    AUTO_MODE_WORKS_AS_MANUAL = "full_trans",
    CONTRIBUTION_OVERFLOW_METER = "contribution_overflow_meter",
    ENABLE_RISK_10 = "enable_risk_10",
    SHOW_VLT = "show_vlt",
    PLAY_BINGO_SOUND_ALL = "play_bingo_sound_all",
    AUTO_ENABLED = "auto_enabled"
}

const BASICGAME_RAMPTYPE = [
    {label: "Disabled", value: 0},
    {label: "Slow", value: 1},
    {label: "Medium", value: 2},
    {label: "Fast", value: 3}
];

const BASICGAME_DURATION = [
    {label: "Constant", value: 0},
    {label: "RAMP", value: 1},
    {label: "MEAN", value: 2}
];

export const SETTINGS_FIELD_NAMES = {
    //[SCHEMA_NAMES.TAX]: "Tax",
    [SCHEMA_NAMES.MAX_BET]: "Max Total Bet Per Game",
    [SCHEMA_NAMES.MIN_TOTAL_BET]: "Min Total Bet",
    //[SCHEMA_NAMES.REPORT_TIME]: "Report Time",
    [SCHEMA_NAMES.AUTO_CASH_OUT]: "Auto Cashout Time",
    [SCHEMA_NAMES.POINTS_SYSTEM]: "Enable Points System",
    [SCHEMA_NAMES.AUTO_SESSION_TIME]: "Auto Session Time",
    [SCHEMA_NAMES.ENABLE_PROG_GLOBAL]: "Enable Prog. Global",
    [SCHEMA_NAMES.GLOBAL_PROG_MASTER]: "Global Prog. Master",
    [SCHEMA_NAMES.GLOBAL_PROG_SERVER]: "Global Prog. Server",
    [SCHEMA_NAMES.GAME_TYPES]: "Game Types",
    [SCHEMA_NAMES.ENABLE_MEGA]: "Enable MEGA",
    [SCHEMA_NAMES.ENABLE_PIG_BOOM]: "Enable Pig Boom",
    [SCHEMA_NAMES.ENABLE_MR_CHAMPION]: "Enable Mr. Champion",
    [SCHEMA_NAMES.EXTRAS_COUNT]: "Extras Count Towards Bet",
    [SCHEMA_NAMES.EXTRA_BALL_PURCHASE]: "Extra Ball Purchase",
    [SCHEMA_NAMES.AUTO_SESSION_ENABLED]: "Auto Session Enabled",
    [SCHEMA_NAMES.UPDATE_TIME]: "Update Time",
    [SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY]:
        "Min. Val. for Prog. Handpay",
    [SCHEMA_NAMES.REGION]: "Region",
    //communication_protocols: "Communication Protocols", // REMOVE COMMUNICATION PROTOCOLS
    [SCHEMA_NAMES.RESET_ON_SUPERVISOR]: "Supervisor",
    [SCHEMA_NAMES.RESET_ON_CASHIN]: "Bill In",
    bingo: "Bingo Settings",
    spins: "Spins Settings",
    [SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL]: "Auto mode as manual mode",
    [SCHEMA_NAMES.ENABLE_RISK_10]: "Enable Risk 0,10€",
    [SCHEMA_NAMES.PLAY_BINGO_SOUND_ALL]: "Play Bingo Sound in all groups"
};

const AUTO_CASH_OUT: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "auto_cash_out",
    id: "SettingsConfigAutoCashOut",
    noValueLabel: "Auto Cashout Time",
    label: "Auto Cashout Time",
    items: [
        {
            label: "No automatic cash-out",
            value: 0
        },
        {
            label: "15 minutes",
            value: 15
        },
        {
            label: "30 minutes",
            value: 30
        },
        {
            label: "45 minutes",
            value: 45
        },
        {
            label: "60 minutes",
            value: 60
        },
        {
            label: "120 minutes",
            value: 120
        }
    ],
    schemaName: SCHEMA_NAMES.AUTO_CASH_OUT
});

/*const REPORT_TIME: TextInputDefinition = buildTextInputDefinition({
    name: "report_time",
    id: "SettingsConfigAutoReportTime",
    placeholder: "HH:MM:SS",
    label: "Report Time",
    schemaName: SCHEMA_NAMES.REPORT_TIME
});*/

const MAX_BET: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_bet",
    id: "SettingsConfigMaxBet",
    placeholder: "Max Total Bet Per Game",
    label: "Max Total Bet Per Game",
    schemaName: SCHEMA_NAMES.MAX_BET
});
const MAX_BET_POINTS: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_bet",
    id: "SettingsConfigMaxBet",
    placeholder: "Max Total Credits Bet",
    label: "Max Total Credits Bet",
    schemaName: SCHEMA_NAMES.MAX_BET
});

const MIN_TOTAL_BET: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_total_bet",
    id: "SettingsConfigMinTotalBet",
    placeholder: "Min Total Bet",
    label: "Min Total Bet",
    schemaName: SCHEMA_NAMES.MIN_TOTAL_BET
});

/*const TAX: NumberInputDefinition = buildNumberInputDefinition({
    name: "tax",
    id: "SettingsConfigTax",
    placeholder: "Tax",
    label: "Tax",
    schemaName: SCHEMA_NAMES.TAX
});*/
/*
// REMOVE COMMUNICATION PROTOCOLS
const COMMUNICATION_PROTOCOLS = (country: string): SelectMenuDefinition =>
    buildSelectMenuDefinition({
        name: "communication_protocols",
        id: "SettingsConfigProtocol",
        noValueLabel: "Select an option...",
        label: "Communication Protocol",
        items:
            country === "PH"
                ? [
                      {
                          label: "SystemServer v1",
                          value: "SystemServer v1"
                      },
                      {
                          label: "PH FBM v12",
                          value: "PH FBM v12"
                      }
                  ]
                : [
                      {
                          label: "SystemServer v1",
                          value: "SystemServer v1"
                      }
                  ],
        schemaName: SCHEMA_NAMES.COMMUNICATION_PROTOCOLS
    });
*/
const AUTO_SESSION_ENABLED = (country: string): SelectMenuDefinition =>
    buildSelectMenuDefinition({
        name: "auto_session_enabled",
        id: "SettingsAutoSessionEnabled",
        noValueLabel: "Select an option...",
        label: "Auto Session Enabled",
        items:
            country === "ES"
                ? [
                    {
                        label: "Manual",
                        value: "manual"
                    },
                    {
                        label: "Automatic",
                        value: "auto"
                    },
                    {
                        label: "Semi-Automatic",
                        value: "semi"
                    }
                ]
                : [
                    {
                        label: "Manual",
                        value: "manual"
                    },
                    {
                        label: "Automatic",
                        value: "auto"
                    }
                ],
        schemaName: SCHEMA_NAMES.AUTO_SESSION_ENABLED
    });

const PLAY_JACKPOT_SOUND_IN_GROUPS: SwitchDefinition = buildSwitchDefinition({
    name: "play_jackpot_sound_all",
    id: "play_jackpot_sound_all",
    label: "Play Mega Sound in all groups",
    schemaName: SCHEMA_NAMES.PLAY_JACKPOT_SOUND_IN_GROUPS
});

const AUTO_SESSION_TIME: TextInputDefinition = buildTextInputDefinition({
    name: "auto_session_time",
    id: "SettingsConfigAutoSessionTime",
    placeholder: "HH:MM:SS",
    label: "Auto Session Time",
    schemaName: SCHEMA_NAMES.AUTO_SESSION_TIME
});

const UPDATE_TIME: DateInputDefinition = buildDateInputDefinition({
    name: "update_time",
    id: "SettingsConfigUpdateTime",
    placeholder: "YYYY-MM-DD HH:MM",
    label: "Update Time",
    schemaName: SCHEMA_NAMES.UPDATE_TIME,
    showtime: true,
    minutesinterval: 5,
    fieldOverrides: {
        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 time",
        formSpacing: false
    }
});

const ENABLE_PROG_GLOBAL: SwitchDefinition = buildSwitchDefinition({
    name: "enable_prog_global",
    id: "SettingsEnableProgGlobal",
    label: "Enable Prog. Global",
    schemaName: SCHEMA_NAMES.ENABLE_PROG_GLOBAL
});

const GLOBAL_PROG_SERVER: SwitchDefinition = buildSwitchDefinition({
    name: "global_prog_server",
    id: "SettingsGlboalProgServer",
    label: "Global Prog. Server",
    schemaName: SCHEMA_NAMES.GLOBAL_PROG_SERVER
});

const GLOBAL_PROG_MASTER: SwitchDefinition = buildSwitchDefinition({
    name: "global_prog_master",
    id: "SettingsGlobalProgMaster",
    label: "Global Prog. Master",
    schemaName: SCHEMA_NAMES.GLOBAL_PROG_MASTER
});

const POINTS_SYSTEM: SwitchDefinition = buildSwitchDefinition({
    name: "points_system",
    id: "PointsSystem",
    label: "Enable Points System",
    schemaName: SCHEMA_NAMES.POINTS_SYSTEM
});

const MINIMUM_VALUE_PROGRESSIVE_HANDPAY: NumberInputDefinition =
    buildNumberInputDefinition({
        name: SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY,
        id: "MinimumValueProgressiveHandpay",
        placeholder:
            SETTINGS_FIELD_NAMES[
                SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY
                ],
        label: SETTINGS_FIELD_NAMES[
            SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY
            ],
        schemaName: SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY
    });

const GAME_TYPES = (
    schema_game_type: string[]
): ButtonSelectorDefinition => {
    let print_game_types = [];
    schema_game_type.map(game_type => {
        game_type === "Spins" && print_game_types.push(
            {
                label: (
                    <span key="spins">
                    <i className="icon-spins-icon"></i>
                    <span>Spins</span>
                </span>
                ),
                value: "Spins"
            }
        )
        game_type === "Bingo" && print_game_types.push(
            {
                label: (
                    <span key="bingo">
                    <i className="icon-bingo-icon"></i>
                    <span>Bingo</span>
                </span>
                ),
                value: "Bingo"
            }
        )
        game_type === "Lotto" && print_game_types.push(
            {
                label: (
                    <span key="lotto">
                    <i className="icon-group-solid"></i>
                    <span>Lotto</span>
                </span>
                ),
                value: "Lotto"
            }
        )
        game_type === "Keno" && print_game_types.push(
            {
                label: (
                    <span key="keno">
                        <i className="icon-th-light"></i>
                    <span>Keno</span>
                </span>
                ),
                value: "Keno"
            }
        )
    })
    return buildButtonSelectorDefinition({
        name: "game_types",
        id: "SettingsConfigGameTypes",
        label: print_game_types.length == 1 ? "Game Type" : "Game Types",
        items: print_game_types,
        schemaName: SCHEMA_NAMES.GAME_TYPES
    });
}

const REGION = (regions: any[]): SelectMenuDefinition => {
    return buildSelectMenuDefinition({
        name: "region",
        id: "SettingsRegion",
        noValueLabel: "Select a region...",
        label: SETTINGS_FIELD_NAMES[SCHEMA_NAMES.REGION],
        items: regions,
        schemaName: SCHEMA_NAMES.REGION
    });
};

const RESET_ON_SUPERVISOR: SwitchDefinition = buildSwitchDefinition({
    name: SCHEMA_NAMES.RESET_ON_SUPERVISOR,
    id: SCHEMA_NAMES.RESET_ON_SUPERVISOR,
    label: SETTINGS_FIELD_NAMES[SCHEMA_NAMES.RESET_ON_SUPERVISOR],
    schemaName: SCHEMA_NAMES.RESET_ON_SUPERVISOR
});

const RESET_ON_CASHIN: SwitchDefinition = buildSwitchDefinition({
    name: SCHEMA_NAMES.RESET_ON_CASHIN,
    id: SCHEMA_NAMES.RESET_ON_CASHIN,
    label: SETTINGS_FIELD_NAMES[SCHEMA_NAMES.RESET_ON_CASHIN],
    schemaName: SCHEMA_NAMES.RESET_ON_CASHIN
});

const AUTO_MODE_WORKS_AS_MANUAL: SwitchDefinition = buildSwitchDefinition({
    name: SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL,
    id: SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL,
    label: SETTINGS_FIELD_NAMES[SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL],
    schemaName: SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL
});

const CONTRIBUTION_OVERFLOW_METER: SwitchDefinition = buildSwitchDefinition({
    name: "contribution_overflow_meter",
    id: "contribution_overflow_meter",
    label: "Overflow Meter",
    schemaName: SCHEMA_NAMES.CONTRIBUTION_OVERFLOW_METER
});

const ENABLE_RISK_10: SwitchDefinition = buildSwitchDefinition({
    name: SCHEMA_NAMES.ENABLE_RISK_10,
    id: SCHEMA_NAMES.ENABLE_RISK_10,
    label: SETTINGS_FIELD_NAMES[SCHEMA_NAMES.ENABLE_RISK_10],
    schemaName: SCHEMA_NAMES.ENABLE_RISK_10
});

const AUTO_ENABLED: SwitchDefinition = buildSwitchDefinition({
    name: "auto_enabled",
    id: "auto_enabled",
    label: "Auto Enabled",
    schemaName: SCHEMA_NAMES.AUTO_ENABLED
});

export const SETTINGS_FORM_DEFINITION: (
    country: string,
    session_type?: string,
    point_system?: boolean,
    form_values?: any,
    schema?: any,
    regions?: any[],
    regionPresets?: any[]
) => FormDefinition = (
    country,
    session_type?,
    point_system?,
    form_values?,
    schema?,
    regions?,
    regionPresets?
) => {
    let fields = {
        [SCHEMA_NAMES.AUTO_CASH_OUT]: {
            definition: {
                ...AUTO_CASH_OUT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 0
        },
        /*[SCHEMA_NAMES.REPORT_TIME]: {
            definition: {
                ...REPORT_TIME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 time"
                }
            },
            order: 1
        },*/
        /*[SCHEMA_NAMES.TAX]: {
            definition: {
                ...TAX,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
                }
            },

            order: 3
        },*/
        /*
        // REMOVE COMMUNICATION PROTOCOLS
        [SCHEMA_NAMES.COMMUNICATION_PROTOCOLS]: {
            definition: {
                ...COMMUNICATION_PROTOCOLS(country),
                fieldOverrides: {
                    formSpacing: false,
                    multipleSelection: true,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 1
        },

         */
        [SCHEMA_NAMES.AUTO_SESSION_ENABLED]: {
            definition: {
                ...AUTO_SESSION_ENABLED(country),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: !(
                        session_type !== undefined && session_type == "auto"
                    )
                        ? "col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9 fake-double-place"
                        : "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 2
        },
        [SCHEMA_NAMES.GAME_TYPES]: {
            definition: {
                ...GAME_TYPES(schema.properties.game_types &&
                schema.properties.game_types.items.enum
                    ? schema.properties.game_types.items.enum
                    : []),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 button-selector"
                }
            },
            order: 4
        },
        [SCHEMA_NAMES.UPDATE_TIME]: {
            definition: {
                ...UPDATE_TIME
            },
            order: 9
        },

        [SCHEMA_NAMES.ENABLE_PROG_GLOBAL]: {
            definition: {
                ...ENABLE_PROG_GLOBAL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 10
        },
        [SCHEMA_NAMES.GLOBAL_PROG_SERVER]: {
            definition: {
                ...GLOBAL_PROG_SERVER,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 11
        },
        [SCHEMA_NAMES.GLOBAL_PROG_SERVER]: {
            definition: {
                ...GLOBAL_PROG_MASTER,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 12
        },
        [SCHEMA_NAMES.POINTS_SYSTEM]: {
            definition: {
                ...POINTS_SYSTEM,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 13
        },
        [SCHEMA_NAMES.PLAY_JACKPOT_SOUND_IN_GROUPS]: {
            definition: {
                ...PLAY_JACKPOT_SOUND_IN_GROUPS,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 14
        },
        [SCHEMA_NAMES.CONTRIBUTION_OVERFLOW_METER]: {
            definition: {
                ...CONTRIBUTION_OVERFLOW_METER,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 14
        }
    };

    if (point_system) {
        fields[SCHEMA_NAMES.REGION] = {
            definition: {
                ...REGION(regions),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 15
        };

        fields[SCHEMA_NAMES.RESET_ON_SUPERVISOR] = {
            definition: {
                ...RESET_ON_SUPERVISOR,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 17
        };

        fields[SCHEMA_NAMES.RESET_ON_CASHIN] = {
            definition: {
                ...RESET_ON_CASHIN,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 18
        };

    } else {
        if (country === "ES" && form_values && form_values.game_types.includes('Bingo')) {
            fields[SCHEMA_NAMES.MAX_BET] = {
                definition: {
                    ...MAX_BET,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
                    }
                },
                order: 15
            };
        }

        //if (country !== "MX") {
        /*
        fields[SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY] = {
            definition: {
                ...MINIMUM_VALUE_PROGRESSIVE_HANDPAY,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
                }
            },
            order: 16
        };

         */
        //}
    }

    if (schema.required.includes(SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY) ||
        !point_system) {
        fields[SCHEMA_NAMES.MINIMUM_VALUE_PROGRESSIVE_HANDPAY] = {
            definition: {
                ...MINIMUM_VALUE_PROGRESSIVE_HANDPAY,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
                }
            },
            order: 16
        };
    }

    if (
        point_system &&
        form_values != undefined &&
        form_values["region"] != undefined &&
        form_values["region"] != null
    ) {
        const selectedRegion = regionPresets.find(
            region => region.id == form_values["region"]
        );

        if (
            selectedRegion &&
            selectedRegion.presets[0].use_bank_and_reserve_in_auto == true
        ) {
            fields[SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL] = {
                definition: {
                    ...AUTO_MODE_WORKS_AS_MANUAL,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass:
                            "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                    }
                },
                order: 16
            };
        }
    }

    if (session_type !== undefined && session_type == "auto") {
        fields[SCHEMA_NAMES.AUTO_SESSION_TIME] = {
            definition: {
                ...AUTO_SESSION_TIME,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-6 col-xl-6 fake-place time"
                }
            },
            order: 3
        };
    }

    /*if (form_values && schema) {
        if (checkIfConditionMeet(form_values, schema)) {
            const optionalFields = {
                update_time: UPDATE_TIME
            };
            schema["then"]["required"].map(key => {
                fields[key] = {
                    definition: {
                        ...optionalFields[key]
                    },
                    order: 15
                };
            });
        }
    }*/

    return fields;
};

export const CONFIGURATION_BINGO_TITLE = "Bingo Settings";
export const CONFIGURATION_SPINS_TITLE = "Spins Settings";
export const CONFIGURATION_POINT_SYSTEM_TITLE = "Points System Settings";
export const CONFIGURATION_PANELS_TITLE = "Panel Settings";
export const CONFIGURATION_LOTTO_TITLE = "Lotto Settings";
export const CONFIGURATION_KENO_TITLE = "Keno Settings";

const ENABLE_MEGA: SwitchDefinition = buildSwitchDefinition({
    name: "enable_mega",
    id: "BingoSettingsMEGA",
    label: "Enable MEGA",
    schemaName: SCHEMA_NAMES.ENABLE_MEGA
});

const ENABLE_PIG_BOOM: SwitchDefinition = buildSwitchDefinition({
    name: "enable_pig_boom",
    id: "BingoSettingsPB",
    label: "Enable Pig Boom",
    schemaName: SCHEMA_NAMES.ENABLE_PIG_BOOM
});

const ENABLE_MR_CHAMPION = (subsidiaryId) => {
    return buildSwitchDefinition({
        name: "enable_mr_champion",
        id: "BingoSettingsMC",
        label: subsidiaryId !== 11 ? "Enable Mr. Champion" : "Enable Manny Bucks",
        schemaName: SCHEMA_NAMES.ENABLE_MR_CHAMPION
    });
}

const EXTRAS_COUNT: SwitchDefinition = buildSwitchDefinition({
    name: "extras_count_towards_bet",
    id: "SettingsConfigBingoExtrasCount",
    label: "Extras Count Towards Bet",
    schemaName: SCHEMA_NAMES.EXTRAS_COUNT
});

export const EXTRA_BALL_PURCHASE_DICT = [
    {label: "No discount on wins", value: 0},
    {label: "First credits, then wins", value: 1},
    {label: "First wins, then credits", value: 2}
];

const EXTRA_BALL_PURCHASE: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "extra_ball_purchase",
    id: "SettingsConfigBingoExtraPurchase",
    noValueLabel: "Select an option...",
    label: "Extra Ball Purchase",
    items: EXTRA_BALL_PURCHASE_DICT,
    schemaName: SCHEMA_NAMES.EXTRA_BALL_PURCHASE
});

const SHOW_VLT: SwitchDefinition = buildSwitchDefinition({
    name: "show_vlt",
    id: "showVlt",
    label: "Show VLT",
    schemaName: SCHEMA_NAMES.SHOW_VLT
});


const PLAY_BINGO_SOUND_ALL: SwitchDefinition = buildSwitchDefinition({
    name: "play_bingo_sound_all",
    id: "playBingoSoundAll",
    label: "Play Bingo Sound in all groups",
    schemaName: SCHEMA_NAMES.PLAY_BINGO_SOUND_ALL
});

export const BINGO_FORM_DEFINITION: (
    country: string,
    points_system?: boolean,
    subsidiaryId?: number
) => FormDefinition = (
    country,
    points_system?,
    subsidiaryId?
) => {
    let fields = {
        [SCHEMA_NAMES.ENABLE_MR_CHAMPION]: {
            definition: {
                ...ENABLE_MR_CHAMPION(subsidiaryId),
                fieldOverrides: {
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3",
                    formSpacing: false
                }
            },
            order: 2
        },
        [SCHEMA_NAMES.EXTRA_BALL_PURCHASE]: {
            definition: {
                ...EXTRA_BALL_PURCHASE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 3
        },
        [SCHEMA_NAMES.PLAY_BINGO_SOUND_ALL]: {
            definition: {
                ...PLAY_BINGO_SOUND_ALL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 5
        },
        [SCHEMA_NAMES.PLAY_JACKPOT_SOUND_IN_GROUPS]: {
            definition: {
                ...PLAY_JACKPOT_SOUND_IN_GROUPS,
                label: "Play Jackpot Sound in all groups",
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-4"
                }
            },
            order: 6
        }
    };

    if (subsidiaryId !== 11) {
        fields[SCHEMA_NAMES.ENABLE_MEGA] = {
            definition: {
                ...ENABLE_MEGA,
                fieldOverrides: {
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3",
                    formSpacing: false
                },
                disabled: country == 'ES'
            },
            order: 0
        }
        fields[SCHEMA_NAMES.ENABLE_PIG_BOOM] = {
            definition: {
                ...ENABLE_PIG_BOOM,
                fieldOverrides: {
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3",
                    formSpacing: false
                }
            },
            order: 1
        }
        fields[SCHEMA_NAMES.EXTRAS_COUNT]= {
            definition: {
            ...EXTRAS_COUNT,
                    fieldOverrides: {
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3",
                        formSpacing: false
                }
            },
            order: 4
        }
        fields[SCHEMA_NAMES.MAX_BET]= {
            definition: {
            ...MAX_BET,
                    fieldOverrides: {
                    formSpacing: false,
                        columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
                }
            },
            order: 5
        }
    }

    return fields;
};

export const SPINS_FORM_DEFINITION: FormDefinition = {
    /*
    [SCHEMA_NAMES.ENABLE_PIG_BOOM]: {
        definition: {
            ...ENABLE_PIG_BOOM,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            }
        },
        order: 0
    },
    [SCHEMA_NAMES.ENABLE_MR_CHAMPION]: {
        definition: {
            ...ENABLE_MR_CHAMPION,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            }
        },
        order: 1
    },
     */
    [SCHEMA_NAMES.MAX_BET]: {
        definition: {
            ...MAX_BET_POINTS,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            }
        },
        order: 1
    },
    [SCHEMA_NAMES.MIN_TOTAL_BET]: {
        definition: {
            ...MIN_TOTAL_BET,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
            }
        },
        order: 0
    }
};

export const LOTTO_FORM_DEFINITION: (
    country: string,
    points_system?: boolean,
    subsidiaryId?: number
) => FormDefinition = (
    country,
    points_system?,
    subsidiaryId?
) => {
    let fields = {
        [SCHEMA_NAMES.PLAY_JACKPOT_SOUND_IN_GROUPS]: {
            definition: {
                ...PLAY_JACKPOT_SOUND_IN_GROUPS,
                label: "Play Jackpot Sound in all groups",
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-4"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.AUTO_ENABLED]: {
            definition: {
                ...AUTO_ENABLED,
                label: "Auto Enabled",
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-4"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.MIN_TOTAL_BET]: {
        definition: {
            ...MIN_TOTAL_BET,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 money"
            }
        },
        order: 2
    }
    };
    return fields;
};

export const KENO_FORM_DEFINITION: (
    country: string,
    points_system?: boolean,
    subsidiaryId?: number
) => FormDefinition = (
    country,
    points_system?,
    subsidiaryId?
) => {
    let fields = {
        [SCHEMA_NAMES.PLAY_JACKPOT_SOUND_IN_GROUPS]: {
            definition: {
                ...PLAY_JACKPOT_SOUND_IN_GROUPS,
                label: "Play Jackpot Sound in all groups",
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-4"
                }
            },
            order: 1
        }
    };
    return fields;
};

export const POINT_SYSTEM_FORM_DEFINITION: (
    regions: any[],
    regionPresets: any[],
    form_values: any
) => FormDefinition = (
    regions,
    regionPresets,
    form_values
) => {
    let selectedRegion = null;
    if (form_values["region_preset"]) {
        selectedRegion = regionPresets.find(
            region => region.id == form_values["region_preset"]["region_id"]
        );
    }
    let fields = {
        [SCHEMA_NAMES.REGION]: {
            definition: {
                ...REGION(regions),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 0
        },
        [SCHEMA_NAMES.AUTO_MODE_WORKS_AS_MANUAL]: {
            definition: {
                ...AUTO_MODE_WORKS_AS_MANUAL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 1
        },
        [SCHEMA_NAMES.RESET_ON_SUPERVISOR]: {
            definition: {
                ...RESET_ON_SUPERVISOR,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 2
        }
    };

    if (
        selectedRegion &&
        selectedRegion.presets[0].risk_10 == true
    ) {
        fields[SCHEMA_NAMES.ENABLE_RISK_10] = {
            definition: {
                ...ENABLE_RISK_10,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 3
        };
    }
    if (
        selectedRegion &&
        selectedRegion.presets[0].risk_10 == false
    ) {
        fields[SCHEMA_NAMES.ENABLE_RISK_10] = {
            definition: {
                ...ENABLE_RISK_10,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                },
                disabled: true
            },
            order: 3
        };
    }


    return fields;
};

export const PANEL_FORM_DEFINITION: FormDefinition = {
    [SCHEMA_NAMES.SHOW_VLT]: {
        definition: {
            ...SHOW_VLT,
            fieldOverrides: {
                formSpacing: false,
                columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            }
        },
        order: 0
    }
};


export const regionPresetKeys = {
    MAX_CREDIT_PRICE: {
        key: "max_credit_price",
        name: "Max. Credit price",
        isMoney: true
    },
    MAX_TOTAL_BET: {
        key: "max_total_bet",
        name: "Max Total bet",
        isMoney: true
    },
    MAX_PRIZE: {key: "max_prize", name: "Max. Prize", isMoney: true},
    MIN_RTP: {key: "min_rtp", name: "RTP Mínimo", isPercentage: true},
    PLAYS_RTP_VALIDATION: {
        key: "plays_rtp_validation",
        name: "Plays To Validate RTP"
    },
    AVG_GAMING_TIME: {
        key: "avg_gaming_time",
        name: "Average Gaming Time",
        isTime: true
    },
    PLAYS_AVG_GAMING_TIME: {
        key: "plays_avg_gaming_time",
        name: "Plays To AGT"
    },
    /*GAME_DURATION_TYPE: {
        key: "game_duration_type",
        name: "Game duration Type"
    },
    GAME_RAMP_TYPE: {
        key: "game_ramp_type",
        name: "Game RAMP Type"
    },*/
    AVG_GAMING_TIME_INTERVAL: {
        key: "avg_gaming_time_interval",
        name: "Interval to AGT",
        isTime: true
    },
    GAME_START_TIME: {
        key: "game_start_time",
        name: "Start of the game",
        isTime: true
    },
    CREDIT_METER_LIMIT: {
        key: "credit_meter_limit",
        name: "Credit Meter Limit",
        isMoney: true
    },
    /*RTP_PERC: {
        key: "rtp_perc",
        name: "RTP %",
        isPercentage: true
    },
    RTP_SECURITY_MARGIN: {
        key: "rtp_security_margin",
        name: "RTP security margin",
        isPercentage: true
    },*/
    IS_MAX_BET_IN_AUTO: {
        key: "is_max_bet_in_auto",
        name: "Max. Bet in Auto"
    },
    USE_BANK_AND_RESERVE_IN_AUTO: {
        key: "use_bank_and_reserve_in_auto",
        name: "Bank and Reserve in Auto"
    },
    IS_AUTO_CASHOUT_ENABLED: {
        key: "is_auto_cashout_enabled",
        name: "Auto Cashout"
    },
    /*MAX_RESERVE_CENTS: {
        key: "max_reserve_cents",
        name: "Max Reserve",
        isMoney: true
    },
    MAX_BANK_CENTS: {
        key: "max_bank_cents",
        name: "Max Bank",
        isMoney: true
    },*/
    TIME_AUTO_CASHOUT_IN_SECONDS: {
        key: "time_auto_cashout_in_seconds",
        name: "Time to Auto Cash Out",
        isTime: true
    },
    AVAILABLE_BETS_IN_CENTS: {
        key: "available_bets_in_cents",
        name: "Available Bets",
        isMoney: true
    },
    /*MAX_PRIZES_PER_BET_IN_CENTS: {
        key: "max_prizes_per_bet_in_cents",
        name: "Max. Prizes per Bet",
        isMoney: true
    }*/
    IS_CONSECUTIVE_MAX_PRIZES_RESTRICTED: {
        key: "is_consecutive_max_prizes_restricted",
        name: "Consecutive Max. Prizes Restricted"
    },
    CASHOUT_LIMIT: {
        key: "cashout_limit",
        name: "Cash Out Limit",
        isMoney: true
    },
    RISK_10: {
        key: "risk_10",
        name: "Risk 0,10€ Approved"
    },
    MAX_PLAY_TIME: {
        key: "max_play_time",
        name: "Max Play Time",
        isTime: true
    }
};

export const regionPresetSchema = _.memoize((): FormGridField[] => [
    {
        name: regionPresetKeys.MAX_CREDIT_PRICE.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_CREDIT_PRICE.key,
            placeholder: regionPresetKeys.MAX_CREDIT_PRICE.name,
            inputType: "text",
            label: regionPresetKeys.MAX_CREDIT_PRICE.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    {
        name: regionPresetKeys.MAX_TOTAL_BET.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_TOTAL_BET.key,
            placeholder: regionPresetKeys.MAX_TOTAL_BET.name,
            inputType: "text",
            label: regionPresetKeys.MAX_TOTAL_BET.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    {
        name: regionPresetKeys.MAX_PRIZE.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_PRIZE.key,
            placeholder: regionPresetKeys.MAX_PRIZE.name,
            inputType: "text",
            label: regionPresetKeys.MAX_PRIZE.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    {
        name: regionPresetKeys.MIN_RTP.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MIN_RTP.key,
            placeholder: regionPresetKeys.MIN_RTP.name,
            inputType: "text",
            label: regionPresetKeys.MIN_RTP.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 percentage",
        formSpacing: false
    },
    {
        name: regionPresetKeys.PLAYS_RTP_VALIDATION.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.PLAYS_RTP_VALIDATION.key,
            placeholder: regionPresetKeys.PLAYS_RTP_VALIDATION.name,
            inputType: "text",
            label: regionPresetKeys.PLAYS_RTP_VALIDATION.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.AVG_GAMING_TIME.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.AVG_GAMING_TIME.key,
            placeholder: regionPresetKeys.AVG_GAMING_TIME.name,
            inputType: "text",
            label: regionPresetKeys.AVG_GAMING_TIME.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 time",
        formSpacing: false
    },
    /*{
        name: regionPresetKeys.GAME_DURATION_TYPE.key,
        fieldType: "select",
        fieldOptions: {
            id: regionPresetKeys.GAME_DURATION_TYPE.key,
            inputType: "text",
            label: regionPresetKeys.GAME_DURATION_TYPE.name,
            disabled: true,
            noValueLabel: "-",
            items: BASICGAME_DURATION
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.GAME_RAMP_TYPE.key,
        fieldType: "select",
        fieldOptions: {
            id: regionPresetKeys.GAME_RAMP_TYPE.key,
            inputType: "text",
            label: regionPresetKeys.GAME_RAMP_TYPE.name,
            disabled: true,
            noValueLabel: "-",
            items: BASICGAME_RAMPTYPE
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3",
        formSpacing: false
    },*/
    {
        name: regionPresetKeys.PLAYS_AVG_GAMING_TIME.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.PLAYS_AVG_GAMING_TIME.key,
            placeholder: regionPresetKeys.PLAYS_AVG_GAMING_TIME.name,
            inputType: "text",
            label: regionPresetKeys.PLAYS_AVG_GAMING_TIME.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.AVG_GAMING_TIME_INTERVAL.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.AVG_GAMING_TIME_INTERVAL.key,
            placeholder: regionPresetKeys.AVG_GAMING_TIME_INTERVAL.name,
            inputType: "text",
            label: regionPresetKeys.AVG_GAMING_TIME_INTERVAL.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 time",
        formSpacing: false
    },
    {
        name: regionPresetKeys.GAME_START_TIME.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.GAME_START_TIME.key,
            placeholder: regionPresetKeys.GAME_START_TIME.name,
            inputType: "text",
            label: regionPresetKeys.GAME_START_TIME.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 time",
        formSpacing: false
    },
    {
        name: regionPresetKeys.CREDIT_METER_LIMIT.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.CREDIT_METER_LIMIT.key,
            placeholder: regionPresetKeys.CREDIT_METER_LIMIT.name,
            inputType: "text",
            label: regionPresetKeys.CREDIT_METER_LIMIT.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },

    /*{
        name: regionPresetKeys.RTP_PERC.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.RTP_PERC.key,
            placeholder: regionPresetKeys.RTP_PERC.name,
            inputType: "text",
            label: regionPresetKeys.RTP_PERC.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 percentage",
        formSpacing: false
    },
    {
        name: regionPresetKeys.RTP_SECURITY_MARGIN.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.RTP_SECURITY_MARGIN.key,
            placeholder: regionPresetKeys.RTP_SECURITY_MARGIN.name,
            inputType: "text",
            label: regionPresetKeys.RTP_SECURITY_MARGIN.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 percentage",
        formSpacing: false
    },*/
    {
        name: regionPresetKeys.IS_MAX_BET_IN_AUTO.key,
        fieldType: "switch",
        fieldOptions: {
            id: regionPresetKeys.IS_MAX_BET_IN_AUTO.key,
            placeholder: regionPresetKeys.IS_MAX_BET_IN_AUTO.name,
            label: regionPresetKeys.IS_MAX_BET_IN_AUTO.name,
            disabled: true
        },
        validation: Yup.string(),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.USE_BANK_AND_RESERVE_IN_AUTO.key,
        fieldType: "switch",
        fieldOptions: {
            id: regionPresetKeys.USE_BANK_AND_RESERVE_IN_AUTO.key,
            placeholder: regionPresetKeys.USE_BANK_AND_RESERVE_IN_AUTO.name,
            label: regionPresetKeys.USE_BANK_AND_RESERVE_IN_AUTO.name,
            disabled: true
        },
        validation: Yup.string(),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.IS_AUTO_CASHOUT_ENABLED.key,
        fieldType: "switch",
        fieldOptions: {
            id: regionPresetKeys.IS_AUTO_CASHOUT_ENABLED.key,
            placeholder: regionPresetKeys.IS_AUTO_CASHOUT_ENABLED.name,
            label: regionPresetKeys.IS_AUTO_CASHOUT_ENABLED.name,
            disabled: true
        },
        validation: Yup.string(),
        columnClass: "col-3",
        formSpacing: false
    },
    /*{
        name: regionPresetKeys.MAX_RESERVE_CENTS.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_RESERVE_CENTS.key,
            placeholder: regionPresetKeys.MAX_RESERVE_CENTS.name,
            inputType: "text",
            label: regionPresetKeys.MAX_RESERVE_CENTS.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    {
        name: regionPresetKeys.MAX_BANK_CENTS.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_BANK_CENTS.key,
            placeholder: regionPresetKeys.MAX_BANK_CENTS.name,
            inputType: "text",
            label: regionPresetKeys.MAX_BANK_CENTS.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },*/
    {
        name: regionPresetKeys.TIME_AUTO_CASHOUT_IN_SECONDS.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.TIME_AUTO_CASHOUT_IN_SECONDS.key,
            placeholder: regionPresetKeys.TIME_AUTO_CASHOUT_IN_SECONDS.name,
            inputType: "text",
            label: regionPresetKeys.TIME_AUTO_CASHOUT_IN_SECONDS.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 time",
        formSpacing: false
    },
    {
        name: regionPresetKeys.AVAILABLE_BETS_IN_CENTS.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.AVAILABLE_BETS_IN_CENTS.key,
            inputType: "text",
            label: regionPresetKeys.AVAILABLE_BETS_IN_CENTS.name,
            placeholder: regionPresetKeys.AVAILABLE_BETS_IN_CENTS.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    /*{
        name: regionPresetKeys.MAX_PRIZES_PER_BET_IN_CENTS.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_PRIZES_PER_BET_IN_CENTS.key,
            inputType: "text",
            label: regionPresetKeys.MAX_PRIZES_PER_BET_IN_CENTS.name,
            placeholder: regionPresetKeys.MAX_PRIZES_PER_BET_IN_CENTS.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    }*/
    {
        name: regionPresetKeys.IS_CONSECUTIVE_MAX_PRIZES_RESTRICTED.key,
        fieldType: "switch",
        fieldOptions: {
            id: regionPresetKeys.IS_CONSECUTIVE_MAX_PRIZES_RESTRICTED.key,
            placeholder:
            regionPresetKeys.IS_CONSECUTIVE_MAX_PRIZES_RESTRICTED.name,
            label: regionPresetKeys.IS_CONSECUTIVE_MAX_PRIZES_RESTRICTED.name,
            disabled: true
        },
        validation: Yup.string(),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.CASHOUT_LIMIT.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.CASHOUT_LIMIT.key,
            inputType: "text",
            label: regionPresetKeys.CASHOUT_LIMIT.name,
            placeholder: regionPresetKeys.CASHOUT_LIMIT.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 money",
        formSpacing: false
    },
    {
        name: regionPresetKeys.RISK_10.key,
        fieldType: "switch",
        fieldOptions: {
            id: regionPresetKeys.RISK_10.key,
            placeholder:
            regionPresetKeys.RISK_10.name,
            label: regionPresetKeys.RISK_10.name,
            disabled: true
        },
        validation: Yup.string(),
        columnClass: "col-3",
        formSpacing: false
    },
    {
        name: regionPresetKeys.MAX_PLAY_TIME.key,
        fieldType: "input",
        fieldOptions: {
            id: regionPresetKeys.MAX_PLAY_TIME.key,
            placeholder: regionPresetKeys.MAX_PLAY_TIME.name,
            inputType: "text",
            label: regionPresetKeys.MAX_PLAY_TIME.name,
            disabled: true
        },
        validation: Yup.string().required("Field is required."),
        columnClass: "col-3 time",
        formSpacing: false
    }
]);
